import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-accordion-panel.css.lit';
import { OutlineAccordionPanel } from 'src/components/base/outline-accordion-panel/outline-accordion-panel';
import { MobileController } from 'src/components/controllers/mobile-controller';
import { classMap } from 'lit/directives/class-map.js';

/**
 * The IdbAccordionPanel component
 * @element idb-accordion-panel
 */

type Variants = 'default' | 'cards' | 'detail-list';
type Levels = 'first' | 'last' | '';
@customElement('idb-accordion-panel')
export class IdbAccordionPanel extends OutlineAccordionPanel {
  private mController = new MobileController(this);

  static styles: CSSResultGroup = [
    OutlineAccordionPanel.styles,
    componentStyles,
  ];

  /**
   * Document property here
   */
  @property({ type: String, attribute: 'property-var' })
  propertyVar: string;

  @property({ type: String, attribute: 'variant' })
  variant: Variants = 'default';

  @property({ type: String, attribute: 'level' })
  level: Levels = '';

  @property({ type: String, attribute: 'attribute-id' })
  attributeId = '';

  render(): TemplateResult {
    const isMobile = this.mController.isMobile ? 'mobile' : null;
    const isClean = this.clean ? 'clean' : null;
    const isActive = this.active ? 'active' : 'inactive';

    const panelClasses = {
      'accordion-panel': true,
      'clean': this.clean,
      [`variant--${this.variant}`]: true,
      [`${this.level}`]: this.level !== '',
      [`${isActive}`]: true,
      'attribute-id': this.attributeId,
    };

    return html` <div class=${classMap(panelClasses)}>
      <div class="accordion-heading">
        <button
          class="accordion-button ${isMobile} ${isActive} ${isClean}"
          id="${this.id}-button"
          aria-expanded=${this.active}
          aria-controls="${this.id}-info"
          @click=${this.setActive}
        >
          <span class="accordion-label ${isMobile}">
            <slot name="heading"> </slot>
          </span>
          <span class="accordion-icon ${isMobile} ${isActive} ${isClean}">
            <outline-icon
              class=${isActive}
              name='chevron-down'
              size="18px"
            ></outline-icon>
          </span>
        </button>
      </div>
      <div
        class="accordion-content ${isMobile}"
        role="region"
        aria-labelledby="${this.id}-button"
        id="${this.id}-info"
        aria-hidden="${!this.active}"
      >
        <slot></slot>
      </div>
    </div>`;
  }
}
